import env from "../../app/config/envHelper";

const baseUrl = env.REACT_APP_BACKEND_URL;
const getReviewsUrl = `/workshops/get-reviews`;
const getRatingsUrl = `/workshops/get-ratings`;
const getDistanceUrl = `/google-maps/distance`;
const getWorkshopsUrl = `/workshops`;
const getWorkshopByIdUrl = `/workshops`;
const getAllWorkshopsUrl = `/workshops/all/details`;
const getThreeRandomWorkshopsUrl = `/workshops/three-random`;
const getWorkshopServicesUrl = `/workshops/services`;
const updateWorkshopUrl = `/workshops/update-workshop`;
const updateWorkshopServicesUrl = `/workshops/update-workshop-services`;
const addWorkshopUrl = `/workshops/workshop`;
const createUploadUrl = `/workshops/create-upload-url`;
const getWorkshopImageUrl = `/workshops/image-url`;
const updateImageKeyUrl = `/workshops/update-image-key`;
const deleteImageKeyUrl = `/workshops/delete-image-key`;
const googleMapsAddressUrl = `/google-maps/address`;
const googleMapsDistanceUrl = `/google-maps/distance`;
const getCarNumberPlateUrl = `/cars`;
const getCarBrandsUrl = `/car-brands`;
const getReservationUrl = `/reservations`;
const getExtraServicesUrl = `/service-catalogue/base-extra`;
const loginUrl = `/auth/login`;
const logoutUrl = `/auth/logout`;
const refreshUrl = `/auth/refresh`;
const newPasswordUrl = `/auth/complete-new-password`;
const getReservationsByWorkshopIdUrl = `/reservations/getReservationsByWorkshopId`;
const getAllBaseServicesUrl = `/service-catalogue/base`;
const getReservationAndServiceCountofAllWorkshopsUrl = `/workshops/reservation-service-count`;
const getPaginatedReservationsUrl = `/reservations/getPaginatedReservations`;
const getAllReservationsCountUrl = `/reservations/getAllReservations/count`;
const updateReservationStatusUrl = `/reservations/updateReservationStatus`;
const getCountOfReservationsByWorkshopIdUrl = `/reservations/getCountOfReservationsByWorkshopId`;
const updateReservationSeenStatusUrl = `/reservations/updateReservationSeenStatus`;

export {
    baseUrl,
    getReviewsUrl,
    getRatingsUrl,
    getDistanceUrl,
    getWorkshopsUrl,
    getWorkshopByIdUrl,
    getThreeRandomWorkshopsUrl,
    getWorkshopServicesUrl,
    googleMapsAddressUrl,
    googleMapsDistanceUrl,
    getCarNumberPlateUrl,
    getCarBrandsUrl,
    getReservationUrl,
    getExtraServicesUrl,
    loginUrl,
    logoutUrl,
    refreshUrl,
    newPasswordUrl,
    getReservationsByWorkshopIdUrl,
    getAllBaseServicesUrl,
    updateWorkshopUrl,
    updateWorkshopServicesUrl,
    getAllWorkshopsUrl,
    getReservationAndServiceCountofAllWorkshopsUrl,
    getPaginatedReservationsUrl,
    getAllReservationsCountUrl,
    updateReservationStatusUrl,
    getCountOfReservationsByWorkshopIdUrl,
    updateReservationSeenStatusUrl,
    addWorkshopUrl,
    createUploadUrl,
    updateImageKeyUrl,
    getWorkshopImageUrl,
    deleteImageKeyUrl
}